/*
 * Contents Module
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/contentsSplit/contents/contentsView",
  "modules/shared/navTree/navTreeModule",
  "modules/contentsSplit/contents/contentsList/contentsListModule",
  "modules/contentsSplit/contents/contentsModel",
  "modules/contentsSplit/contents/contentsSearch/contentsSearchModule",
], function (
  Marionette,
  Messenger,
  ContentsView,
  NavTreeModule,
  ContentsListModule,
  ContentsModel,
  ContentsSearchModule,
) {
  var ContentsController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "contents";
      this.region = options.region;
      this._setUpVents();
    },
    save: function () {
      console.log("saving contents");
      if (this.rootContentGroup) {
        this.rootContentGroup.saveModel();
      } else {
        Messenger.saveAttempted(true); //success
      }
    },
    show: function () {
      this.rootContentGroup = Messenger.reqres.request("root:content:group");
      this.layout = new ContentsView.contentsLayout();
      this.navTree = this.addSubModule(
        new NavTreeModule({
          region: this.layout.contentsTree,
          nameAttribute: "groupName",
          namespace: "contents",
        }),
      );
      this.navList = this.addSubModule(
        new ContentsListModule({
          region: this.layout.contentsList,
          rootContentGroup: this.rootContentGroup,
        }),
      );
      this.search = this.addSubModule(
        new ContentsSearchModule({ region: this.layout.contentsSearch }),
      );
      this.layout.on(
        "add:content",
        function () {
          this.addNewContent();
        },
        this,
      );
      this.layout.on(
        "show",
        function () {
          this._showSubViews();
        },
        this,
      );
      this.showRegion(this.layout);
    },
    _showSubViews: function () {
      this.navTree.show(this.rootContentGroup); //pass root content folder object
      //show the root folder
      this.navTree.view.on(
        "show",
        function () {
          this.rootContentGroup.onSynced(function () {
            //make sure that we have not selected something else already!
            if (!this.navList.isOpen) {
              this.rootContentGroup.trigger("select");
            }
          }, this);
        },
        this,
      );
      this.search.show();
    },
    _setUpVents: function () {
      //show the results of a search
      Messenger.vent.on(
        "contents:search:results",
        function (groupModel) {
          //          this.selectedTopicGroup = null;
          //          //since there could be modifications made to topics in the search, we reset the topics nav tree
          this.rootContentGroup.clearContentCollections();
          Messenger.vent.trigger("contents:clear:selection"); //deselect whatever the nav tree had already selected, if anything
          groupModel.set("groupName", groupModel.get("name"));
          this.navList.show(groupModel);
        },
        this,
      );

      //trigger to show the missing content search
      Messenger.vent.on(
        "missing:content:search",
        function (localeId) {
          if (this.layout) {
            //show the search pane
            this.layout.showSearchPane();
            this.search.setSelectedLocale(localeId);
            //select the missing search (reach into the view to get the # for the desired search--kind of bad but better than a hardcoded value)
            this.search.changeSearchMode(this.search.view.SEARCH_BY_MISSING);
            //trigger search
            this.search.triggerSearch(localeId);
          }
        },
        this,
      );

      //trigger to show the modified content search
      Messenger.vent.on(
        "modified:content:search",
        function (localeId) {
          if (this.layout) {
            //show the search pane
            this.layout.showSearchPane();
            this.search.setSelectedLocale(localeId);
            //select the modified search (reach into the view to get the # for the desired search--kind of bad but better than a hardcoded value)
            this.search.changeSearchMode(this.search.view.SEARCH_BY_MODIFIED);
            //trigger search
            this.search.triggerSearch(localeId);
          }
        },
        this,
      );

      //The starting point for adding new content from content awareness
      Messenger.vent.on(
        "add:content",
        function (url) {
          this.addNewContent();
        },
        this,
      );
    },
    addNewContent: function (url) {
      Messenger.save(function (success) {
        if (success) {
          var newContent;
          //if a content group has been selected, add the content to that group, otherwise, add it to the root group
          if (this.navList.group !== null && this.navList.group.get("groupId") >= 0) {
            //make sure we aren't looking at search results
            newContent = this.navList.group.addContent();
          } else {
            //if we are in a search or no folder has been selected
            newContent = this.rootContentGroup.addContent();
          }
          //show the content page for the new content
          Messenger.vent.trigger("show:content", newContent);
        }
      }, this);
    },
  });

  return ContentsController;
});
